export class Clock {
  constructor({ stepSeconds = 1 / 60, maxFrameSeconds = 0.25 } = {}) {
    this.stepSeconds = stepSeconds;
    this.maxFrameSeconds = maxFrameSeconds;
    this.accumulator = 0;
    this.simulationTime = 0;
    this.timeScale = 1;
    this.paused = false;
  }

  setTimeScale(value) {
    if (!Number.isFinite(value) || value < 0 || value > 20) {
      throw new RangeError('timeScale must be between 0 and 20');
    }
    this.timeScale = value;
  }

  setPaused(paused) {
    this.paused = Boolean(paused);
  }

  reset({ simulationTime = 0, timeScale = 1, paused = true } = {}) {
    if (!Number.isFinite(simulationTime) || simulationTime < 0) {
      throw new RangeError('simulationTime must be a non-negative finite number');
    }
    this.setTimeScale(timeScale);
    this.accumulator = 0;
    this.simulationTime = simulationTime;
    this.paused = Boolean(paused);
    return this.snapshot();
  }

  update(realDeltaSeconds, fixedUpdate) {
    if (this.paused) return 0;
    const safeDelta = Math.min(Math.max(realDeltaSeconds, 0), this.maxFrameSeconds);
    this.accumulator += safeDelta * this.timeScale;

    let steps = 0;
    while (this.accumulator >= this.stepSeconds) {
      fixedUpdate(this.stepSeconds, this.simulationTime);
      this.simulationTime += this.stepSeconds;
      this.accumulator -= this.stepSeconds;
      steps += 1;
    }
    return steps;
  }

  advance(seconds, fixedUpdate) {
    if (!Number.isFinite(seconds) || seconds < 0) {
      throw new RangeError('seconds must be a non-negative finite number');
    }
    const steps = Math.floor(seconds / this.stepSeconds);
    for (let index = 0; index < steps; index += 1) {
      fixedUpdate(this.stepSeconds, this.simulationTime);
      this.simulationTime += this.stepSeconds;
    }
    return steps;
  }

  snapshot() {
    return {
      stepSeconds: this.stepSeconds,
      simulationTime: this.simulationTime,
      timeScale: this.timeScale,
      paused: this.paused,
    };
  }
}
